module.exports = __webpack_public_path__ + "img/sierra.56f32378.jpg";